export const PathsUrls = {
  home_v2: '/',
  about: '/about',
  ourTeam: '/our-team',
  careers: '/careers',
  contactUs: '/contact-us',
  application: '/application',
  privacyPolicy: '/privacy-policy',
  termsofservice: '/Terms-of-service-screen'
};
